import { FC, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TFolder, TItem, useFolder } from '@modules/items';
import { AccessType } from '@modules/access';
import { StatusLabel } from '@shared/components';

import { useTags } from '../api';
import { TRegulatoryTagsData, TTag } from '../types';
import RegulatoryTagsContent from '../components/RegulatoryTagsContent';
import { useDocumentTitle } from '@shared/hooks';

const RegulatoryTags: FC = () => {
  const { id } = useParams();
  const productId = id as string;

  const { error: folderError, data: folder } = useFolder(productId);
  const { error: tagsError, data: tagsData } = useTags(productId);

  const error = folderError || tagsError;

  // useMemo would be better then a useState + useEffect
  const data: TRegulatoryTagsData | null = useMemo(() => {
    if (folder && tagsData) {
      return {
        folder: folder as TFolder,
        tagsData: tagsData as TTag[],
      };
    }
    return null;
  }, [folder, tagsData]);

  useDocumentTitle('Regulatory tags');

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading tags..."
      error={error}
      errorMessage="Loading tags failed!"
      render={(resolvedData) => <RegulatoryTagsContent data={resolvedData} />}
    />
  );
};

export default RegulatoryTags;
